var React = require('react');

function Network (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.625 5v1.835H20v1.25h-4.375V10h1.877c.46 0 .831.376.831.826v3.348a.832.832 0 0 1-.83.826h-5.005a.832.832 0 0 1-.831-.826v-3.348c0-.456.377-.826.83-.826h1.878V8.085h-8.75V10h1.954c.458 0 .83.376.83.826v3.348a.832.832 0 0 1-.83.826H2.574a.832.832 0 0 1-.831-.826v-3.348c0-.456.377-.826.83-.826h1.802V8.085H0v-1.25h9.375V5H7.574a.832.832 0 0 1-.831-.826V.826c0-.456.377-.826.83-.826h5.006c.458 0 .83.376.83.826v3.348a.832.832 0 0 1-.83.826h-1.954zM8.076 3.667h4V1.333h-4v2.334zm-5 10h4v-2.334h-4v2.334zm9.924 0h4v-2.334h-4v2.334z","fill":"currentColor","fillRule":"evenodd"}));
}

Network.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15"};

module.exports = Network;

Network.default = Network;
